export function numToStr(id: number) {
  return id + '';
}

export function convertDBTimestampToDateStr(timestampDBStr: string) {
  try {
    // console.log(createAt);
    return timestampDBStr.split('T')[0];
  } catch {
    return '2025-01-01';
  }
}
